import { createFileRoute, redirect } from "@tanstack/react-router";

import { DASHBOARD_PATH, LOGIN_PATH } from "~/routes/-route-constants/appRoutes.ts";

/**
 * The home screen app starts here. A redirect replaces this history entry. A <Navigate> pushes a second one, and a back
 * from the dashboard then comes here, shows an empty page, and goes forward to the dashboard again.
 */
export const Route = createFileRoute("/")({
    beforeLoad: ({ context }) => {
        throw redirect({ to: context.auth.user ? DASHBOARD_PATH : LOGIN_PATH });
    },
});
